class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=10&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }
      var flky = new Flickity('.search-row', {
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        cellAlign: 'left'
      });
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
    $('.snippet-search-bar').addClass('opensnippet');
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
    $('.snippet-search-bar').removeClass('opensnippet');
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
var header_height = document.querySelector('.section-header').offsetHeight;
var windowscroll = $(window).scrollTop();
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
      document.querySelector('body').classList.add('default-header');      
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
      if(windowscroll<header_height){
        document.querySelector('body').classList.remove('default-header');      
      }    
    });    
  });
  document.querySelectorAll('.list-menu > .magelistnav').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      document.querySelector('body').classList.add('overlay-header');
    });
    navList.addEventListener('mouseout', function(){
      document.querySelector('body').classList.remove('overlay-header');
    });
  });
}
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-searchbox');
  } 
};
$(window).on('load',function(e){
  setTimeout(function(){
    $('.book_appointment').addClass('active');
  },5000);
});